import React from "react";
import { PageHero, SectionLabel } from "@/components/Sections";
import { COMPANY } from "@/lib/data";

export default function Integritetspolicy() {
  return (
    <>
      <PageHero
        eyebrow="Integritetspolicy"
        title="Så hanterar vi era personuppgifter"
        intro="Här beskriver vi kort hur Rena Tjänster behandlar personuppgifter som lämnas via vårt offertformulär eller annan kontakt med oss."
      />

      <section className="py-16 lg:py-24" data-testid="policy-content">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate">
          <SectionLabel className="mb-4">Personuppgiftsansvarig</SectionLabel>
          <h2 className="font-display text-2xl font-semibold mt-0 mb-3 text-slate-900">{COMPANY.name}</h2>
          <p className="text-slate-700 leading-relaxed">
            {COMPANY.address}<br />
            E-post: <a href={`mailto:${COMPANY.email}`} className="text-[#1E3A6F] underline">{COMPANY.email}</a><br />
            Telefon: <a href={COMPANY.phoneLink} className="text-[#1E3A6F] underline">{COMPANY.phone}</a>
          </p>

          <h2 className="font-display text-2xl font-semibold mt-10 mb-3 text-slate-900">Vilka uppgifter samlar vi in?</h2>
          <p className="text-slate-700 leading-relaxed">
            När ni fyller i offertformuläret på vår hemsida samlar vi in uppgifter som ni själva väljer
            att lämna: företag/verksamhet, kontaktperson, e-postadress, telefonnummer, önskad tjänst
            och meddelande.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-10 mb-3 text-slate-900">Varför hanterar vi uppgifterna?</h2>
          <p className="text-slate-700 leading-relaxed">
            Vi använder uppgifterna för att hantera er förfrågan, återkomma med en offert och föra en
            normal affärsrelation om ni blir kund hos oss. Den rättsliga grunden är avtal eller ert
            samtycke när ni skickar in förfrågan.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-10 mb-3 text-slate-900">Hur länge sparas uppgifterna?</h2>
          <p className="text-slate-700 leading-relaxed">
            Förfrågningar som inte leder till uppdrag raderas normalt inom 12 månader. Vid kundförhållande
            sparas uppgifterna så länge det är nödvändigt för att fullgöra uppdraget och uppfylla
            bokföringskrav enligt svensk lag.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-10 mb-3 text-slate-900">Vilka delas uppgifterna med?</h2>
          <p className="text-slate-700 leading-relaxed">
            Uppgifterna delas inte med tredje part utöver de leverantörer vi anlitar för att driva
            hemsidan och e-postutskick. Dessa leverantörer hanterar uppgifterna enligt
            personuppgiftsbiträdesavtal och i enlighet med GDPR.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-10 mb-3 text-slate-900">Era rättigheter</h2>
          <p className="text-slate-700 leading-relaxed">
            Ni har rätt att begära ut, rätta eller radera era personuppgifter samt att invända mot
            behandlingen. Kontakta oss på <a href={`mailto:${COMPANY.email}`} className="text-[#1E3A6F] underline">{COMPANY.email}</a> så
            hanterar vi er begäran. Ni har också rätt att lämna klagomål till Integritetsskydds&shy;myndigheten (IMY).
          </p>

          <h2 className="font-display text-2xl font-semibold mt-10 mb-3 text-slate-900">Cookies och spårning</h2>
          <p className="text-slate-700 leading-relaxed">
            Vår hemsida använder inte tredjepartscookies för marknadsföring eller spårning. Eventuella
            tekniska cookies används endast för att hemsidan ska fungera.
          </p>
        </div>
      </section>
    </>
  );
}
